import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Create"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-create',
    templateUrl: './icon-create.component.html',
    styleUrls: ['./icon-create.component.scss'],
    standalone: false
})
export class IconCreateComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
